import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';

import Iconify from 'src/components/Iconify';
import { useTwilioVoice } from './TwilioVoiceProvider';

export default function TwilioCallActionButton({
    to,
    leadId,
    lead,
    phoneId,
    disabled,
    tooltip = 'Call with Twilio',
    sx,
    onCallStart,
}) {
    // The one dialer (CU-869fmbgfj): Elevate desk callers use it too.
    const { canOpen, isCalling, openDialer } = useTwilioVoice();

    if (!canOpen) return null;

    const isDisabled = disabled || isCalling || (!to && !leadId);

    return (
        <Tooltip title={isDisabled ? 'Call unavailable' : tooltip} arrow>
            <span>
                <IconButton
                    size="small"
                    onClick={() => {
                        onCallStart?.();
                        openDialer({ to, leadId, lead, phoneId });
                    }}
                    disabled={isDisabled}
                    aria-label={tooltip}
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '10px',
                        border: '1px solid',
                        color: 'primary.main',
                        bgcolor: 'rgba(7, 141, 238, 0.08)',
                        borderColor: 'rgba(7, 141, 238, 0.28)',
                        '&:hover': { bgcolor: 'rgba(7, 141, 238, 0.14)' },
                        '&.Mui-disabled': {
                            color: '#919EAB',
                            borderColor: 'rgba(145,158,171,0.24)',
                            bgcolor: 'transparent',
                        },
                        ...sx,
                    }}
                >
                    <Iconify icon="solar:phone-calling-rounded-bold" width={18} />
                </IconButton>
            </span>
        </Tooltip>
    );
}

TwilioCallActionButton.propTypes = {
    to: PropTypes.string,
    leadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lead: PropTypes.object,
    phoneId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    sx: PropTypes.object,
    onCallStart: PropTypes.func,
};
